import calendarPrintHeaderUrl from './calendarPrintHeader.html';
export default {
  templateUrl: calendarPrintHeaderUrl,
  controllerAs: 'ctrl',
  bindings: {
    mode: '<',
    processingMode: '<',
    date: '<',
    currentDays: '<',
    currentAllDays: '<',
  },
};
